import { ApolloClient } from '@apollo/client';
import { DisplayFilters } from 'src/utils/filters/display-filters';
import {
  UpdateCartMutation,
  UpdateCartMutationVariables,
} from 'src/ts/@types/generated/graphql/cart-order-service/graphql';
import { UPDATE_CART } from 'src/graphql-operations/cart-order-service/carts.mutation';
import { ClientNames } from 'src/utils/apolloClient';
import { FunnelCart } from 'src/ts/types/cart';
import _ from 'lodash';

export const setSellableCartPreferences = async (input: {
  apolloClient: ApolloClient;
  selectedFilters: DisplayFilters;
  cart: FunnelCart;
}) => {
  const { apolloClient, selectedFilters, cart } = input;

  const ingredientToAvoidIds =
    selectedFilters.ingredientsToAvoid?.map(
      (ingredientToAvoid) => ingredientToAvoid.legacyAllergenItemId,
    ) || [];

  const tagIds =
    selectedFilters.tagCategories?.flatMap((tagCategory) =>
      tagCategory.tags.map((tag) => tag.id),
    ) || [];

  const macros = selectedFilters.macros?.length
    ? selectedFilters.macros.reduce(
        (acc, macro) => {
          acc[macro.key] = { min: macro.min, max: macro.max };
          return acc;
        },
        {} as Record<string, { min: number; max: number | null }>,
      )
    : {};

  const funnelDataFilters = {
    ingredientToAvoidIds,
    tagIds,
    macros,
  };

  // If the cart has the same filters, there's no need to update. Just return
  if (_.isEqual(cart['funnelData']['filters'], funnelDataFilters)) {
    return;
  }

  await apolloClient.mutate<UpdateCartMutation, UpdateCartMutationVariables>({
    mutation: UPDATE_CART,
    context: { clientName: ClientNames.CART_ORDER_GRAPH },
    variables: {
      uuid: cart.uuid,
      funnelData: {
        filters: {
          ingredientToAvoidIds,
          tagIds,
          macros,
        },
      },
    },
  });
};
